var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrunchbaseIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m64 8c0-4.4174-3.5826-8-8-8h-48c-4.4174 0-8 3.5826-8 8v48c0 4.4174 3.5826 8 8 8h48c4.4174 0 8-3.5826 8-8z",
    clipRule: "evenodd",
    fill: "#445cff",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.414,
    strokeWidth: 0.10475
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.3849 0 0 2.3849 -9.545 -43.547)",
    fill: "#fff",
    strokeWidth: 0.57409
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.94 33.658a2.9623 2.9623 0 1 1 0.03444-2.4399h2.2963a5.1668 5.1668 0 1 0 0 2.4399h-2.2963z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.511 27.257h-0.3789a5.0979 5.0979 0 0 0-2.526 0.88983v-5.7523h-2.0954v14.794h2.1069v-0.53964a5.1668 5.1668 0 1 0 2.8934-9.392zm2.9623 5.5342v0.09185a2.9393 2.9393 0 0 1-0.08037 0.36167 2.9336 2.9336 0 0 1-0.14352 0.37316v0.04593a2.9795 2.9795 0 0 1-2.0724 1.6247l-0.2813 0.04593h-0.06315a2.9164 2.9164 0 0 1-0.32149 0 2.9623 2.9623 0 0 1-0.40186-0.02871h-0.09185a2.9336 2.9336 0 0 1-0.75205-0.22963h-0.05741a2.9738 2.9738 0 0 1-0.66594-0.44779 2.991 2.991 0 0 1-0.52242-0.62575 2.9623 2.9623 0 0 1-0.18945-0.36741 2.9451 2.9451 0 0 1 0.03445-2.4399 2.968 2.968 0 0 1 2.3767-1.6821 2.9336 2.9336 0 0 1 0.30426 0 2.968 2.968 0 0 1 2.9278 2.8819 2.9565 2.9565 0 0 1 0 0.39612z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrunchbaseIcon);
export default __webpack_public_path__ + "assets/media/crunchbaseIcon.11f81310.svg";
export { ForwardRef as ReactComponent };